import noop from 'lodash/noop';
import { fromCallback } from 'xstate';

import { type SessionSoundPlayer } from '@eluve/sounds';

export type SoundEvents = {
  type:
    | 'PLAY.PAUSE'
    | 'PLAY.STOP'
    | 'PLAY.START'
    | 'PLAY.ALERT'
    | 'PLAY.DISCLAIMER'
    | 'PLAY.DISCLAIMER.ENDED';
};

type Input = {
  soundPlayer: SessionSoundPlayer;
};

export const playSoundEffects = fromCallback<SoundEvents, Input, SoundEvents>(
  ({ receive, input: { soundPlayer }, sendBack, emit }) => {
    receive((event) => {
      if (event.type === 'PLAY.PAUSE') {
        soundPlayer.play('pauseStop');
      }
      if (event.type === 'PLAY.STOP') {
        soundPlayer.play('pauseStop');
      }
      if (event.type === 'PLAY.START') {
        soundPlayer.play('start');
      }
      if (event.type === 'PLAY.ALERT') {
        soundPlayer.play('alert');
      }
      if (event.type === 'PLAY.DISCLAIMER') {
        soundPlayer.play('disclaimer');
        soundPlayer.on('disclaimer', 'end', () => {
          const disclaimerEndedEvent: SoundEvents = {
            type: 'PLAY.DISCLAIMER.ENDED',
          };
          sendBack(disclaimerEndedEvent);
          emit(disclaimerEndedEvent);
        });
      }
    });
    return noop;
  },
);
